<template>
  <lx-line display-type='变速器同步器'
           apiIndentity='synchronize'
           nav-active='4-1-3'>
  </lx-line>
</template>

<script>
import ProcessLine from '@/components/teaching/ProcessLine'
export default {
  data () {
    return {
    }
  },

  components: { 'lx-line': ProcessLine }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/teaching/synchronize/SynchronizeProcessLine.vue